class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const trigger = event.currentTarget;
        const id = trigger.dataset.popup;
        const popup = document.getElementById(id);
        if (!popup) return;
        popup.classList.add('show');
        trigger.setAttribute('aria-expanded', 'true');
        document.querySelector('#halo-cart-sidebar .previewCart')?.classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('#halo-cart-sidebar .popup-toolDown.show')?.classList.remove('show');
      document.querySelector('#halo-cart-sidebar .previewCart')?.classList.remove('active-tool');
      document.querySelectorAll('#halo-cart-sidebar [data-popup]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('[data-update-coupon]');
    this.status = this.querySelector('.agfn-coupon-status');

    try {
      const storedDiscount = localStorage.getItem('storedDiscount');
      if (storedDiscount && this.input) {
        this.input.value = storedDiscount;
      }
    } catch (error) {
      // The coupon still works when browser storage is unavailable.
    }

    this.button?.addEventListener('click', () => this.updateCoupon());
    this.input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.updateCoupon();
      }
    });
  }

  updateCoupon() {
    const code = this.input?.value.trim() || '';
    if (!code || this.button?.disabled) {
      if (this.status && !code) this.status.textContent = 'Enter a coupon code.';
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    const updateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;
    const originalButtonText = this.button.textContent;

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.textContent = 'Applying…';
    if (this.status) this.status.textContent = 'Updating your coupon code…';

    fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().catch(() => ({})).then((error) => {
            throw new Error(error.description || error.message || 'The coupon code could not be updated.');
          });
        }
        return response.json();
      })
      .then((cart) => {
        try {
          localStorage.setItem('storedDiscount', code);
        } catch (error) {
          // Browser storage is optional.
        }

        if (this.status) this.status.textContent = 'Coupon code updated.';
        document.querySelector('#halo-cart-sidebar .popup-toolDown.show')?.classList.remove('show');
        document.querySelector('#halo-cart-sidebar .previewCart')?.classList.remove('active-tool');
        document.querySelectorAll('#halo-cart-sidebar [data-popup]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        if (window.sharedFunctions?.updateSidebarCart) {
          window.sharedFunctions.updateSidebarCart(cart);
        } else if (window.Shopify?.getCart) {
          window.Shopify.getCart((updatedCart) => {
            window.sharedFunctions?.updateSidebarCart(updatedCart);
          });
        }
      })
      .catch((error) => {
        if (this.status) this.status.textContent = error.message;
      })
      .finally(() => {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.button.textContent = originalButtonText;
      });
  }
}

customElements.define('coupon-code', CouponCode);
